import React, { useEffect, useRef, useState } from 'react';
import { FaLeaf, FaSpa, FaUserFriends, FaHome, FaWhatsapp, FaHandsHelping, FaCircle, FaFlower } from 'react-icons/fa';
import styles from './Services.module.css';

const Services = () => {
  const [visibleCards, setVisibleCards] = useState([]);
  const sectionRef = useRef(null);

  const services = [
    {
      id: 1,
      title: 'Body Massage',
      description: 'Full body relaxation massage to relieve stress and tension',
      icon: FaHandsHelping,
      price: 'Starting ₹1500',
      image: '/images/body-massage.png'
    },
    {
      id: 2,
      title: 'Aromatherapy Massage',
      description: 'Essential oils massage for deep relaxation and healing',
      icon: FaLeaf,
      price: 'Starting ₹1800',
      image: '/images/aromatherapy.png'
    },
    {
      id: 3,
      title: 'Swedish Massage',
      description: 'Classic massage technique for muscle relaxation',
      icon: FaSpa,
      price: 'Starting ₹1600',
      image: '/images/swedish.png'
    },
    {
      id: 4,
      title: 'Thai Massage',
      description: 'Traditional Thai yoga massage with stretching techniques',
      icon: FaCircle,
      price: 'Starting ₹1700',
      image: '/images/thai.png'
    },
    {
      id: 5,
      title: 'Couple Massage',
      description: 'Romantic massage experience for couples',
      icon: FaUserFriends,
      price: 'Starting ₹3000',
      image: '/images/couple.png'
    },
    {
      id: 6,
      title: 'Home Service',
      description: 'Professional massage service at your doorstep',
      icon: FaHome,
      price: 'Starting ₹2000',
      image: '/images/home.png'
    }
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const cardIndex = parseInt(entry.target.dataset.index);
            setVisibleCards(prev => [...new Set([...prev, cardIndex])]);
          }
        });
      },
      { threshold: 0.2 }
    );

    const cards = sectionRef.current?.querySelectorAll('[data-service-card]');
    cards?.forEach((card) => observer.observe(card));

    return () => observer.disconnect();
  }, []);

  const handleBookNow = (serviceName) => {
    const message = `Hi, I would like to book ${serviceName}. Please share the details.`;
    window.open(`https://wa.me/916204009260?text=${encodeURIComponent(message)}`, '_blank');
  };

  return (
    <section className={styles.services} ref={sectionRef}>
      <div className={styles.container}>
        <div className={styles.sectionHeader}>
          <h2 className={styles.title}>Our Premium Services</h2>
          <p className={styles.subtitle}>Experience luxury and relaxation with our expert massage therapies</p>
        </div>

        <div className={styles.servicesGrid}>
          {services.map((service, index) => {
            const IconComponent = service.icon;
            const isVisible = visibleCards.includes(index);

            return (
              <div
                key={service.id}
                className={`${styles.serviceCard} ${isVisible ? styles.visible : ''}`}
                data-index={index}
                data-service-card
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className={styles.cardImageContainer}>
                  <img src={service.image} alt={service.title} className={styles.cardImage} />
                  <div className={styles.iconOverlay}>
                    <IconComponent className={styles.serviceIcon} />
                  </div>
                </div>

                <div className={styles.cardContent}>

                  <h3 className={styles.serviceTitle}>{service.title}</h3>
                  <p className={styles.serviceDescription}>{service.description}</p>
                  <div className={styles.servicePrice}>{service.price}</div>

                  <button
                    className={styles.bookBtn}
                    onClick={() => handleBookNow(service.title)}
                  >
                    <FaWhatsapp /> Book Now
                  </button>
                </div>

                <div className={styles.cardGlow}></div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;